export default "__VITE_ASSET__ou9wKjLT__"